import Vue from 'vue'
import { Component, Prop} from 'vue-property-decorator'

@Component({

})
export default class SearchButton extends Vue {

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) value!: string;

}